import {internationalDigitsFromNational, isValidMobilePhoneNational} from '../../../functions/phoneValidation';

export type PhoneFormValues = {phone: string; country: string};
export type PhoneChangeMode = 'regular' | 'secure';
export type Step = 'phone' | 'code' | 'success';

export const parsePhoneForOrder = (nationalNumber: string, country: string): string =>
    internationalDigitsFromNational(nationalNumber, country);

export const normalizePhoneDigits = (phone: string | undefined, country?: string): string => {
    if(!phone) return '';
    let d = String(phone).replace(/\D/g, '');
    if(d.startsWith('0') && country === 'IL') d = `972${d.slice(1)}`;
    return d;
};

export function computePhoneFormatOk(value: string, country: string): boolean {
    return isValidMobilePhoneNational(value, country);
}

export function computeTenDigitsOk(value: string, country: string): boolean {
    if(!value) return false;
    if(country !== 'IL') return computePhoneFormatOk(value, country);
    const rawDigits = String(value).replace(/\D/g, '');
    if(rawDigits.startsWith('972')) return `0${rawDigits.slice(3)}`.length === 10;
    return rawDigits.length === 10;
}

export function computeDiffersFromCurrentOk(value: string, country: string, currentPhone: string | undefined): boolean {
    const phoneForApi = parsePhoneForOrder(value, country);
    const nextD = normalizePhoneDigits(phoneForApi, country);
    const curD = currentPhone ? normalizePhoneDigits(currentPhone, country) : '';
    return !curD || (!!nextD && nextD !== curD);
}

export const formatCurrentPhoneDisplay = (raw: string | undefined): string => {
    if(!raw) return '—';
    const d = String(raw).replace(/\D/g, '');
    let local = d;
    if(d.startsWith('972')) local = `0${d.slice(3)}`;
    if(local.length >= 10) return `${local.slice(0, 3)}-${local.slice(3, 6)}-${local.slice(6, 10)}`;
    return raw;
};
